import React, { Component } from 'react';
import {
  getDisplayModelInfo,
  getNetText,
  addNewModelToComponents,
  getDisplayCompName,
  deleteOldModelByComponents,
  handleDeleteModelFile,
  editModelTypeByComponents
} from '../../../../services/Andes_v2/channel/channelBuilder';
import AddNewModelPopover from './components/AddNewModelPopover';
import AutoPortMatch from './components/AutoPortMatch';
import ClickOutsideManager from '../../Manager/ClickOutsideManager';
import ModelRender from './components/ModelRender';
import ModelTitleItem from './components/ModelTitleItem';
import './index.css';

class ChannelBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      txModelInfoList: [],
      signalPinList: [],
      rxModelInfoList: [],
      modelTitleList: [],
      // node popover
      nodePopoverVisible: false,
      // all file info, {libraryId: {fileName, type, ports | models}}
      fileInfoList: {},
      dropdownVisible: "", // "tx"/"rx"/""
      creatingModel: false,
      txComps: [],
      autoPortMatchParams: {},
      // fileVisibleList: [],
    }

    this.fileColors = {};
  }

  componentDidMount() {
    this.unsubscribe = ClickOutsideManager.subscribe(this.handleClickOutside);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const PopoverRoot = document.getElementsByClassName('spice-node-select-Popover')[0];
    const SelectRoot = document.getElementsByClassName('nodes-list-file-dropdown')[0];

    if (!PopoverRoot) {
      return;
    }

    if (PopoverRoot && !PopoverRoot.contains(target) && (!SelectRoot || !SelectRoot.contains(target))) {
      this.setNodePopoverVisible("");
    }
  }

  updateContent = async () => {
    const { currentComp, otherComponents, signals, serdesType } = this.props;
    const {
      txModelInfoList = [],
      signalPinList = [],
      rxModelInfoList = [],
      modelTitleList = [],
      fileInfoList = {},
      txComps = [],
      resFileColors = {}
    } = await getDisplayModelInfo(currentComp, otherComponents, signals, serdesType, this.fileColors) || {};

    this.fileColors = resFileColors;
    this.setState({
      txModelInfoList,
      signalPinList,
      rxModelInfoList,
      modelTitleList,
      fileInfoList,
      txComps
    })
  }

  deleteModelFile = (item, file, type) => {
    const { components, currentComp } = this.props;
    const newComponents = handleDeleteModelFile(file, type, item.modelType, item.modelIndex, components, currentComp);
    this.props.updateChannelComponents(newComponents, true);
  }

  // getCollapseItems = (txModelInfoList, rxModelInfoList) => {
  //   const ItemDIV = (item, index) => {
  //     const { files = [], modelType = "", modelName = "" } = item;
  //     const displayFiles = getDisplayModelFiles(files, modelType)
  //     return <div className='file-box' key={`file-box-${modelType}-${index}`}>
  //       <label>{modelType || modelName ? `${modelType || modelName} Model` : ""}</label>
  //       {displayFiles.length > 0
  //         ? <div className='input-group'>
  //           {displayFiles.map((file, i) => (
  //             <div className="input-box" key={`file-${modelType}-${index}-${file.libraryId}-${i}`}>
  //               <Input value={file.fileName} className='file-input' disabled />
  //               {file.type.toLowerCase() === SPICE ? <Input value={file.subckt} className='file-input' disabled /> : null}
  //               <Tag className="circle-tag" color="blue">{file.number}</Tag>
  //               {file.isExist
  //                 ? <CloseOutlined
  //                   className='delete-model-file-icon'
  //                   onClick={() => this.deleteModelFile(item, file, index < txModelInfoList.length ? 'tx' : 'rx')}
  //                 />
  //                 : <Tooltip title={`Files ${file.fileName} has been deleted, the model is invalid.`}>
  //                   <QuestionCircleOutlined className='file-not-exist-icon' />
  //                 </Tooltip>}
  //             </div>
  //           ))}
  //         </div>
  //         : <div className="input-group">
  //           <Input className='file-input' disabled />
  //         </div>}
  //     </div>
  //   }
  //   return [
  //     {
  //       key: 'model-files',
  //       label: 'Model Files',
  //       children: <Space direction="vertical">
  //         {[...txModelInfoList, ...rxModelInfoList].map((item, index) => {
  //           // return modelType === DIE && topology === SERIES && termination.type.toLowerCase() === SPICE
  //           //   ? <Fragment key={`file-box-${modelType}-${index}`}>
  //           //     {ItemDIV(item, index)}
  //           //     {ItemDIV({ ...termination, modelType: DIE_TERMINATION, modelIndex }, index)}
  //           //   </Fragment>
  //           //   : <Fragment key={`file-box-${modelType}-${index}`}>{ItemDIV(item, index)}</Fragment>
  //           return <Fragment key={`file-box-${item.modelType || ""}-${index}`}>{ItemDIV(item, index)}</Fragment>
  //         })}
  //       </Space>
  //     }
  //   ]
  // }

  // --> model box and port select popover<--
  setNodePopoverVisible = (nodePopoverVisible) => {
    this.setState({ nodePopoverVisible })
  }

  modelRender = (modelInfo, type) => {
    const { modelType = "", modelIndex } = modelInfo;
    const { fileInfoList, nodePopoverVisible } = this.state;
    const { designType, serdesType, signals, components, libraryStatus } = this.props;
    return <ModelRender
      key={`${type}-${modelType}-${modelIndex}`}
      nodePopoverVisible={nodePopoverVisible}
      fileInfoList={fileInfoList}
      setNodePopoverVisible={this.setNodePopoverVisible}
      modelInfo={modelInfo}
      type={type}
      designType={designType}
      serdesType={serdesType}
      signals={signals}
      components={components}
      libraryStatus={libraryStatus}
      updateChannelComponents={this.props.updateChannelComponents}
      fileColors={this.fileColors}
    />
  }

  // ---> add new model box <---
  deleteOldModel = (modelIndex, type) => {
    const { txComps } = this.state;
    const { components, currentComp } = this.props;
    const newComponents = deleteOldModelByComponents(modelIndex, components, type === 'tx' ? txComps : [currentComp]);
    this.props.updateChannelComponents(newComponents, true);
  }

  addNewModel = (modelType, key, modelIndex, type) => {
    const { txComps } = this.state;
    const { components, currentComp } = this.props;
    let addIndex = 0;
    switch (key) {
      case 'tx':
      case 'rx':
        addIndex = "end";
        break;
      default:
        addIndex = Number(modelIndex);
        break;
    }
    const newComponents = addNewModelToComponents(addIndex, modelType, components, key === 'tx' || type === 'tx' ? txComps : [currentComp]);
    this.setState({ dropdownVisible: "" });
    this.props.updateChannelComponents(newComponents, true);
  }

  addNewModelDropdownRender = (key, modelIndex, type, className) => {
    const { designType, serdesType, currentComp } = this.props;
    const { dropdownVisible, txModelInfoList, rxModelInfoList, txComps } = this.state;
    return <AddNewModelPopover
      type={type}
      popoverKey={key}
      designType={designType}
      serdesType={serdesType}
      className={className}
      dropdownVisible={dropdownVisible}
      comps={type === 'tx' || key === 'tx' ? txComps : [currentComp]}
      modelTypeList={(type === 'tx' || key === 'tx' ? txModelInfoList : rxModelInfoList).map(item => item.modelType)}
      addNewModel={(modelType) => this.addNewModel(modelType, key, modelIndex, type)}
      onOpenChange={(open) => this.setState({ dropdownVisible: open ? key : "" })}
    />
  }

  openAutoPortMatch = (id, modelType, modelIndex, type) => {
    const { txModelInfoList, rxModelInfoList, txComps } = this.state;
    const { currentComp } = this.props;

    const modelInfoList = type === 'tx' ? txModelInfoList : rxModelInfoList;
    const { files, pairs, topology } = modelInfoList.find(item => item.modelIndex === modelIndex);
    this.setState({
      autoPortMatchParams: {
        id,
        modelType,
        modelIndex,
        type,
        modelFileKey: modelType,
        files,
        pairs,
        topology,
        targetComps: type === 'tx' ? txComps : [currentComp]
      },
    })
  }

  // setFileVisibleList = (id, allSeleted) => {
  //   if (typeof allSeleted !== 'undefined') {
  //     this.setState({ fileVisibleList: allSeleted ? "all" : [] });
  //     return;
  //   }
  //   const { fileVisibleList } = this.state;
  //   this.setState({ fileVisibleList: fileVisibleList.includes(id) ? fileVisibleList.filter(item => item !== id) : [...fileVisibleList, id] })
  // }

  editModelType = (modelType, modelIndex, type) => {
    const { txComps } = this.state;
    const { components, currentComp } = this.props;
    const newComponents = editModelTypeByComponents(modelType, modelIndex, components, type === 'tx' ? txComps : [currentComp]);
    this.props.updateChannelComponents(newComponents, true);
  }

  render() {
    const {
      txModelInfoList,
      signalPinList,
      rxModelInfoList,
      modelTitleList,
      autoPortMatchParams,
      // fileVisibleList,
      txComps
    } = this.state;
    const { designType, currentComp, components } = this.props;
    const { txCompName, rxCompName } = getDisplayCompName(currentComp, txComps);

    return <>
      {this.props.compNameTitleRender ? this.props.compNameTitleRender(rxCompName) : null}
      {/* <Collapse
        className="andes-v2-channel-builder-model-files-collapse"
        defaultActiveKey={['model-files']}
        bordered={false}
        items={this.getCollapseItems(txModelInfoList, rxModelInfoList)}
      /> */}
      {/* <div className='andes-v2-channel-builder-setting-container'>
        <div className='setting-item'>
          <label>Display all model files</label>
          <Switch size="small" onChange={(checked) => this.setFileVisibleList("", checked)} />
        </div>
      </div> */}
      <div className='andes-v2-channel-builder-container-border'>
        <div className="andes-v2-channel-builder-container">
          <div className="andes-v2-channel-builder-title">
            {modelTitleList.map((modelTitleInfo, index) =>
              <ModelTitleItem
                id={`title-${modelTitleInfo.type}-${modelTitleInfo.modelType}-${index}`}
                key={`title-${modelTitleInfo.type}-${modelTitleInfo.modelType}-${index}`}
                comps={modelTitleInfo.type === 'tx' ? txComps : [currentComp]}
                txCompName={txCompName}
                designType={designType}
                rxCompName={rxCompName}
                modelTitleInfo={modelTitleInfo}
                // fileVisibleList={fileVisibleList}
                portMatchId={autoPortMatchParams.id}
                modelTypeList={(modelTitleInfo.type === 'tx' ? txModelInfoList : rxModelInfoList).map(item => item.modelType)}
                // setFileVisibleList={this.setFileVisibleList}
                openAutoPortMatch={this.openAutoPortMatch}
                deleteOldModel={this.deleteOldModel}
                deleteModelFile={this.deleteModelFile}
                editModelType={this.editModelType}
                addNewModelDropdownRender={this.addNewModelDropdownRender}
                fileColors={this.fileColors}
              />
            )}
          </div>
          <div className="andes-v2-channel-builder-content">
            {/* connect line */}
            <div className="line-box">
              {Array.from({ length: signalPinList.length }).map((_, index) => (
                <div key={`connect-line-${index}`}>
                  <hr className="connect-line" />
                </div>
              ))}
            </div>
            {/* add model box */}
            <div className="add-new-model-box" onClick={() => this.setState({ dropdownVisible: "tx" })} title='Add new model.'>
              {this.addNewModelDropdownRender('tx')}
            </div>
            {/* Tx Package Model */}
            {txModelInfoList.map((modelInfo) => this.modelRender(modelInfo, 'tx'))}
            {/* PCB */}
            <div className="pcb-box">
              {signalPinList.map(({ pin_in, pin_out }, i) => (
                <div className="port-box" key={`${pin_in.pin}-${pin_out.pin}-${i}`}>
                  <div className="pin-name">{pin_in.pin}</div>
                  <div className="circle-line"></div>
                  <div className="net-box">
                    <div className="signal-name">{pin_in.signal || pin_out.signal}</div>
                    <div className="net-name">{getNetText(pin_in.net, pin_out.net)}</div>
                  </div>
                  <div className="circle-line"></div>
                  <div className="pin-name">{pin_out.pin}</div>
                </div>
              ))}
            </div>
            {/* Rx Connector Model */}
            {rxModelInfoList.map((modelInfo) => this.modelRender(modelInfo, 'rx'))}
            {/* add model box */}
            <div className="add-new-model-box" onClick={() => this.setState({ dropdownVisible: "rx" })} title='Add new model.'>
              {this.addNewModelDropdownRender('rx')}
            </div>
          </div>
        </div>
      </div>
      {Object.keys(autoPortMatchParams).length > 0 ? <AutoPortMatch
        components={components}
        autoPortMatchParams={autoPortMatchParams}
        closeAutoPortMatch={() => this.setState({ autoPortMatchParams: {} })}
        updateChannelComponents={this.props.updateChannelComponents}
      /> : null}
    </>
  }
}

export default ChannelBuilder;